var _circle, _circle2, _circle3, _circle4, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGroupIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 28,
    cy: 28,
    r: 28,
    fill: "white"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 25.5,
    cy: 29.5,
    r: 12,
    fill: "white",
    stroke: "#2C6FC4"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 27.5,
    cy: 27.5,
    r: 12,
    fill: "white",
    stroke: "#2C6FC4"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 29.5,
    cy: 25.5,
    r: 12,
    fill: "white",
    stroke: "#2C6FC4"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.2582 21.6061V20.2853C32.2582 19.979 32.4018 19.7684 32.6889 19.6536C32.9761 19.5387 33.2249 19.5866 33.4355 19.7971L35.9048 22.2665C36.0005 22.3622 36.058 22.4675 36.0771 22.5824C36.1154 22.6972 36.1154 22.8121 36.0771 22.9269C36.058 23.0418 36.0005 23.1471 35.9048 23.2428L33.4355 25.7121C33.2249 25.9227 32.9761 25.9705 32.6889 25.8557C32.4018 25.7408 32.2582 25.5303 32.2582 25.224V23.9032H23.5867C23.357 23.9032 23.2422 23.7883 23.2422 23.5586V21.9507C23.2422 21.7209 23.357 21.6061 23.5867 21.6061H32.2582Z",
    fill: "#5596F9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.1186 29.9564V31.2772C27.1186 31.5835 26.975 31.7941 26.6879 31.9089C26.4008 32.0238 26.1519 31.9759 25.9413 31.7653L23.472 29.296C23.338 29.162 23.271 28.9993 23.271 28.8079C23.271 28.6164 23.338 28.4537 23.472 28.3197L25.9413 25.8504C26.1519 25.6398 26.4008 25.5919 26.6879 25.7068C26.975 25.8217 27.1186 26.0322 27.1186 26.3385V27.6593H35.7901C36.0198 27.6593 36.1346 27.7742 36.1346 28.0039V29.6118C36.1346 29.8415 36.0198 29.9564 35.7901 29.9564H27.1186Z",
    fill: "#2C6FC4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroupIcon);
export default __webpack_public_path__ + "static/media/group-icon.50b956616de30348104bc867bf2225ee.svg";
export { ForwardRef as ReactComponent };